.header {
  text-align: right;
  padding-right: 2em;
  white-space: nowrap;
}
